(function () {
  if (window.lbColorSwatches) return;

  const cache = new Map();
  let pushed = false;

  const sectionOf = (el) => el && el.closest('[id^="shopify-section-"]');
  const labelOf = (el) => sectionOf(el)?.querySelector('.lb-colors__name');

  function parse(value, fallback) {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return fallback;
    }
  }

  const variantsOf = (swatch) => parse(swatch.dataset.variants, {});
  const availableOf = (swatch) => parse(swatch.dataset.available, []);
  const hasSize = (swatch, size) => availableOf(swatch).includes(size);

  function selectedInput(section) {
    return section.querySelector('variant-radios-detail input[type="radio"]:checked');
  }

  function fetchSection(url, sectionId, variantId) {
    const key = `${url}|${sectionId}|${variantId || ''}`;
    if (!cache.has(key)) {
      const params = new URLSearchParams({ section_id: sectionId });
      if (variantId) params.set('variant', variantId);
      const request = fetch(`${url}?${params}`)
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .catch((error) => {
          cache.delete(key);
          throw error;
        });
      cache.set(key, request);
    }
    return cache.get(key);
  }

  function targetFor(swatch, size) {
    const variantId = size ? variantsOf(swatch)[size] : null;
    return { variantId, pageUrl: swatch.dataset.url + (variantId ? `?variant=${variantId}` : '') };
  }

  function prefetch(swatch) {
    const section = sectionOf(swatch);
    if (!section || swatch.classList.contains('is-active')) return;
    const { variantId } = targetFor(swatch, selectedInput(section)?.value);
    fetchSection(swatch.dataset.url, section.id.replace('shopify-section-', ''), variantId).catch(() => {});
  }

  function preloadImages(section) {
    section.querySelectorAll('.lb-colors__swatch:not(.is-active)').forEach((swatch) => {
      if (swatch.dataset.image) new Image().src = swatch.dataset.image;
    });
  }

  async function switchColor(swatch, forcedSize) {
    const section = sectionOf(swatch);
    if (!section || swatch.classList.contains('is-active')) return;

    const size = forcedSize || selectedInput(section)?.value;
    const { variantId, pageUrl } = targetFor(swatch, size);
    const sectionId = section.id.replace('shopify-section-', '');
    const previousTitle = section.querySelector('.lb-colors__swatch.is-active')?.dataset.title;
    const scrollY = window.scrollY;

    section.classList.add('lb-colors-switching');
    try {
      const html = await fetchSection(swatch.dataset.url, sectionId, variantId);
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(section.id);
      if (!fresh || !fresh.querySelector('[data-lb-colors]')) throw new Error('Section not found');

      section.innerHTML = fresh.innerHTML;
      history.pushState({ lbColors: true }, '', pageUrl);
      pushed = true;
      if (previousTitle && swatch.dataset.title) {
        document.title = document.title.replace(previousTitle, swatch.dataset.title);
      }
      window.scrollTo(0, scrollY);
      syncSoldOutState(section);
      refresh(section, { reveal: true });
      preloadImages(section);
    } catch (error) {
      window.location.href = pageUrl;
    } finally {
      section.classList.remove('lb-colors-switching');
    }
  }

  function syncSoldOutState(section) {
    const input = selectedInput(section);
    if (input && input.classList.contains('option-disabled')) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function markSizesElsewhere(picker, siblings) {
    picker.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = picker.querySelector(`label[for="${input.id}"]`);
      if (!label) return;
      const elsewhere = input.classList.contains('option-disabled') && siblings.some((swatch) => hasSize(swatch, input.value));
      label.classList.toggle('lb-size-elsewhere', elsewhere);
    });
  }

  function popFor(picker) {
    let pop = picker.parentElement.querySelector(':scope > .lb-size-pop');
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'lb-size-pop';
    pop.setAttribute('role', 'status');
    pop.setAttribute('aria-live', 'polite');
    pop.hidden = true;
    picker.insertAdjacentElement('afterend', pop);
    return pop;
  }

  function placeCaret(pop, input) {
    const label = input && input.closest('variant-radios-detail')?.querySelector(`label[for="${input.id}"]`);
    if (!label || pop.hidden) return;
    const labelBox = label.getBoundingClientRect();
    const popBox = pop.getBoundingClientRect();
    const x = Math.min(Math.max(labelBox.left + labelBox.width / 2 - popBox.left, 18), popBox.width - 18);
    pop.style.setProperty('--lb-caret-x', `${x}px`);
  }

  function hidePop(pop) {
    pop.hidden = true;
    pop.replaceChildren();
  }

  function renderPop(pop, size, colorName, others) {
    const caret = document.createElement('span');
    caret.className = 'lb-size-pop__caret';
    caret.setAttribute('aria-hidden', 'true');

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'lb-size-pop__close';
    close.setAttribute('aria-label', 'Cerrar');
    close.innerHTML =
      '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';

    const title = document.createElement('p');
    title.className = 'lb-size-pop__title';
    if (others.length) {
      const names = others.map((swatch) => swatch.dataset.name);
      const list = names.length > 1 ? `${names.slice(0, -1).join(', ')} y ${names[names.length - 1]}` : names[0];
      title.textContent = `Tu talla ${size} está disponible en color ${list}`;
    } else {
      title.textContent = `Tu talla ${size} está agotada en todos los colores`;
    }

    const children = [caret, close, title];

    if (others.length) {
      const options = document.createElement('div');
      options.className = 'lb-size-pop__options';
      others.forEach((swatch) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'lb-size-pop__option';
        option.dataset.url = swatch.dataset.url;
        option.dataset.size = size;
        const dot = document.createElement('span');
        dot.className = 'lb-size-pop__dot';
        dot.setAttribute('style', swatch.getAttribute('style') || '');
        const name = document.createElement('span');
        name.textContent = swatch.dataset.name;
        const tag = document.createElement('span');
        tag.className = 'lb-size-pop__tag';
        tag.textContent = `Talla ${size}`;
        option.append(dot, name, tag);
        options.append(option);
      });
      children.push(options);
    }

    const dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'lb-size-pop__dismiss';
    dismiss.textContent = others.length ? `Ver otras tallas en ${colorName}` : 'Elegir otra talla';
    children.push(dismiss);

    pop.replaceChildren(...children);
  }

  function refresh(section, options = {}) {
    if (!section) return;
    const colors = section.querySelector('[data-lb-colors]');
    const picker = section.querySelector('variant-radios-detail');
    if (!colors || !picker) return;

    const active = colors.querySelector('.lb-colors__swatch.is-active');
    const siblings = [...colors.querySelectorAll('.lb-colors__swatch:not(.is-active)')];
    markSizesElsewhere(picker, siblings);

    const pop = popFor(picker);
    const input = selectedInput(section);
    const size = input?.value;
    if (!size || !active || hasSize(active, size) || !(size in variantsOf(active))) {
      hidePop(pop);
      return;
    }

    const others = siblings.filter((swatch) => hasSize(swatch, size));
    renderPop(pop, size, active.dataset.name, others);
    pop.hidden = false;
    placeCaret(pop, input);

    if (options.reveal) {
      const box = pop.getBoundingClientRect();
      if (box.bottom > window.innerHeight || box.top < 0) {
        pop.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest('.lb-colors__swatch');
    if (!swatch) return;
    const label = labelOf(swatch);
    if (label) label.textContent = swatch.dataset.name;
    prefetch(swatch);
  });

  document.addEventListener('mouseout', (event) => {
    const swatch = event.target.closest('.lb-colors__swatch');
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    const label = labelOf(swatch);
    if (label) label.textContent = label.dataset.current;
  });

  document.addEventListener(
    'touchstart',
    (event) => {
      const swatch = event.target.closest('.lb-colors__swatch, .lb-size-pop__option');
      if (!swatch) return;
      const target = swatch.classList.contains('lb-colors__swatch')
        ? swatch
        : sectionOf(swatch)?.querySelector(`.lb-colors__swatch[data-url="${swatch.dataset.url}"]`);
      if (target) prefetch(target);
    },
    { passive: true }
  );

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.lb-colors__swatch');
    if (swatch) {
      event.preventDefault();
      switchColor(swatch);
      return;
    }

    const option = event.target.closest('.lb-size-pop__option');
    if (option) {
      const target = sectionOf(option)?.querySelector(`.lb-colors__swatch[data-url="${option.dataset.url}"]`);
      if (target) switchColor(target, option.dataset.size);
      return;
    }

    const sizeLabel = event.target.closest('variant-radios-detail label[for]');
    if (sizeLabel) {
      const input = document.getElementById(sizeLabel.htmlFor);
      if (input && input.checked) refresh(sectionOf(sizeLabel));
      return;
    }

    const closer = event.target.closest('.lb-size-pop__close, .lb-size-pop__dismiss');
    if (closer) {
      const pop = closer.closest('.lb-size-pop');
      const picker = pop.previousElementSibling;
      hidePop(pop);
      if (closer.classList.contains('lb-size-pop__dismiss') && picker) {
        picker.querySelector('input[type="radio"]:not(.option-disabled) + label')?.focus({ preventScroll: true });
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.lb-size-pop:not([hidden])').forEach(hidePop);
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-radios-detail')) refresh(sectionOf(event.target));
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.lb-size-pop:not([hidden])').forEach((pop) => {
      const section = sectionOf(pop);
      if (section) placeCaret(pop, selectedInput(section));
    });
  });

  window.addEventListener('popstate', () => {
    if (pushed) window.location.reload();
  });

  function init() {
    document.querySelectorAll('[data-lb-colors]').forEach((colors) => {
      const section = sectionOf(colors);
      syncSoldOutState(section);
      refresh(section);
      preloadImages(section);
    });
  }

  window.lbColorSwatches = { refresh, switchColor };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
